import React from 'react';
import PropTypes from 'prop-types';

import './LatestBlogBanner.scss';

import PostCard from './PostCard';

const LatestBlogBanner = props => {
  const { blogBannerTitle } = props;
  return (
    <div className="latest-blog-banner">
      <h1>{blogBannerTitle}</h1>
      {props.children}
    </div>
  );
};

LatestBlogBanner.propTypes = {
  blogBannerTitle: PropTypes.string,
  children: PropTypes.object,
};

export default LatestBlogBanner;



// WEBPACK FOOTER //
// ./src/components/Main/home/LatestBlogBanner.js